import PortalVue from 'portal-vue';
import Vue from 'vue';
import VueCookies from 'vue-cookies';
import VueLazyload from 'vue-lazyload';

import VetsterButton from '@/brand-components/VetsterButton';
import VetsterInput from '@/brand-components/VetsterInput';
import VetsterNav from '@/brand-components/VetsterNav';
import VetsterButtonLegacy from '@/components/VetsterButtonLegacy';
import VetsterConfirm from '@/components/VetsterConfirm';
import VetsterError from '@/components/VetsterError';
import VetsterInputLegacy from '@/components/VetsterInputLegacy';
import VetsterNotice from '@/components/VetsterNotice';
import VetsterPageSpinner from '@/components/VetsterPageSpinner';
import VetsterPagination from '@/components/VetsterPagination';
import VetsterSearchBar from '@/components/VetsterSearchBar';
import VetsterSearchBeta from '@/components/VetsterSearchBeta';
import VetsterSearchPanel from '@/components/VetsterSearchPanel';
import VetsterSearchTile from '@/components/VetsterSearchTile';
import useCookies from '@/composables/use-cookies';
import useKeyboardEvents from '@/composables/use-keyboard-events';
import usePvarsStorage from '@/composables/use-pvars-storage';
import registerFontAwesomeSearch from '@/config/fontAwesomeSearch';
import registerVueTippy from '@/config/tooltips';
import VetsterScroll from '@/directives/VetsterScroll';
import { getCookie } from '@/helpers/cookies';
import { isDevelopment } from '@/helpers/environment';
import storeDeviceData from '@/helpers/storeDeviceData';
import { i18n } from '@/i18n';
import TogglesSupportChat from '@/mixins/TogglesSupportChat';
import Analytics from '@/packages/Analytics';
import Api from '@/packages/Api';
import Auth from '@/packages/Auth';
import { fullStoryReadyCallback } from '@/packages/FullStory';
import Sentry from '@/packages/Sentry';
import { initStatsig } from '@/packages/Statsig';
import EventBus from '@/plugins/EventBus';
import Layout from '@/plugins/Layout';
import Responsive from '@/plugins/Responsive';
import store from '@/store';

Vue.directive('vetster-scroll', VetsterScroll);

registerFontAwesomeSearch();
registerVueTippy();

if (isDevelopment()) {
  Vue.component('VetsterDebug', () => import('./components/VetsterDebug'));
}

Vue.component('VetsterToast', () => import('./brand-components/VetsterToast'));

Vue.component('VetsterAuthModalLegacy', () => import('./components/VetsterAuthModalLegacy'));
Vue.component('VetsterAuthFormsLegacy', () => import('./components/VetsterAuthFormsLegacy')); // ensures lazy loading of google auth
Vue.component('VetsterAuthSlideOver', () => import('./brand-components/VetsterAuthSlideOver'));
Vue.component('VetsterConfirmation', () => import('./brand-components/VetsterConfirmation'));

// Load global plugins.
Vue.use(Analytics);
Vue.use(EventBus);
Vue.use(Layout);
Vue.use(Responsive);
Vue.use(PortalVue);
Vue.use(VueCookies);
Vue.use(VueLazyload, {
  observer: true,
});
Vue.use(Sentry);

const uat = getCookie('v-uatid');

Vue.use(Api, { uat });
Vue.use(Auth, { uat });

initStatsig(Vue, uat);

Vue.component('VetsterButton', VetsterButton);
Vue.component('VetsterButtonLegacy', VetsterButtonLegacy);
Vue.component('VetsterConfirm', VetsterConfirm);
Vue.component('VetsterError', VetsterError);
Vue.component('VetsterInput', VetsterInput);
Vue.component('VetsterInputLegacy', VetsterInputLegacy);
Vue.component('VetsterNotice', VetsterNotice);
Vue.component('VetsterPageSpinner', VetsterPageSpinner);
Vue.component('VetsterPagination', VetsterPagination);
Vue.component('VetsterSearchBar', VetsterSearchBar);
Vue.component('VetsterSearchPanel', VetsterSearchPanel);
Vue.component('VetsterSearchTile', VetsterSearchTile);

// Log the user's device info.
storeDeviceData();

// eslint-disable-next-line no-new
new Vue({
  el: '#app',

  name: 'AdvancedSearch',

  components: {
    VetsterNav,
    VetsterSearchBeta,
  },

  mixins: [TogglesSupportChat],

  setup() {
    const {
      getViMessage,
      hasViMessage,
      openCookiePreferences,
      removeViMessage,
    } = useCookies();
    const { emitCloseOnEscape } = useKeyboardEvents();
    const { latestPvars } = usePvarsStorage();

    return {
      emitCloseOnEscape,
      getViMessage,
      hasViMessage,
      latestPvars,
      openCookiePreferences,
      removeViMessage,
    };
  },

  store,

  i18n,

  created() {
    store.$app = this;
    store.state.$auth = this.$auth;

    this.emitCloseOnEscape();
    this.$analytics.trackUAT(uat);
    this.$analytics.trackPageLoad();
    fullStoryReadyCallback(this.$sentry);
  },
});
